// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"3c7d76f6","453":"8191d5a1","842":"e7ed5b7d"}[chunkId] + ".chunk.js";
};